// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_g0-0";
export var headerCellHover = "_g0-1";
export var readCellContainer = "_g0-2";
export var unreadIndicator = "_g0-3";